define('app/factories/home_travel_widget_factory',['app/setup','app/views/home_travel_widget_view'],
  function(takhfifan,HomeTravelWidgetView) {
    $('.tkh-home-page-travel-widget').each(function(){
      new takhfifan.HomeTravelWidgetView({
        el: $(this)
      });
    });
  });
